export class CarserviceFamily {
}
//# sourceMappingURL=carservice-family.js.map